import { useQuery } from "@tanstack/react-query";
import createPrivateAdminPanelInstance from "../../api/PrivateAdminPanelInstance";
import { API_ROUTES } from "../../api/ApiRoutes";
import { bonusAdminBody } from "./bonusAdminBody";
import type { SegmentOut } from "../../components/Promotions/DynamicBonuses/types";

type StoredToken = { AccessToken?: string };

async function fetchSegment(segmentId: string): Promise<SegmentOut> {
  const tokenString = localStorage.getItem("token");
  const token: StoredToken | null = tokenString ? JSON.parse(tokenString) : null;
  const instance = createPrivateAdminPanelInstance(token?.AccessToken);
  const url = API_ROUTES.GET_DYNAMIC_BONUS_SEGMENT.replace("{segment_id}", segmentId);
  const response = await instance.get(url);
  const segment = bonusAdminBody<SegmentOut>(response);
  if (!segment) {
    throw new Error("Segment not found");
  }
  return segment;
}

export const getSegmentQueryKey = (segmentId: string) =>
  ["GET_DYNAMIC_BONUS_SEGMENT", segmentId] as const;

export const useGetSegment = (segmentId: string) => {
  return useQuery<SegmentOut>({
    queryKey: getSegmentQueryKey(segmentId),
    queryFn: () => fetchSegment(segmentId),
    enabled: Boolean(segmentId),
    staleTime: 1000 * 60,
    refetchOnWindowFocus: false,
  });
};
